<template>
	<div class="input-group">
		<select placeholder="请选择" v-model="corpInfo.provinceId"  class="select w74 mr10 nopadding" @change="getCityList">
			<option value="0">-省-</option>
			<option :value="item.provinceId" v-for="item in provinceList">{{item.name}}</option>
		</select>
		<select placeholder="请选择" v-model="corpInfo.cityId"  class="select w74 mr10  nopadding" @change="getAreaList">
			<option value="0">-市-</option>
			<option :value="item.cityId" v-for="item in cityList">{{item.name}}</option>
		</select>
		<select placeholder="请选择" v-model="corpInfo.areaId"  class="select w74 mr10  nopadding" @change="getStreetList">
			<option value="0">-区县-</option>
			<option :value="item.areaId" v-for="item in areaList">{{item.name}}</option>
		</select>
		<select placeholder="请选择" v-model="corpInfo.streetId"  class="select w74  nopadding">
			<option value="0">-街道-</option>
			<option :value="item.streetId" v-for="item in streetList">{{item.name}}</option>
		</select>
	</div>
</template>

<script>
	export default{
		name:'getArea',
		data(){
			return{
				
			}
		},
		mounted:function(){
			this.getProvinceList();
		},
		methods:{
			getProvinceList(){
				//获取省
				let url = "/ajax/district/province";
				this.$ajax.get(url).then((res) => {
					this.provinceList = res.result;					
					this.getCityList();
				})
				.catch((err) => {
					console.log(err);
				});
			},
			 //获取市列表
		    getCityList(){
				if (this.corpInfo.provinceId==0) return true;
		    	let url="/ajax/district/city/"+this.corpInfo.provinceId;
		    	this.$ajax.get(url).then((res) => {
					this.cityList = res.result;	
					this.streetList=[];
					this.areaList=[];	
					this.corpInfo.cityId=0;			
					this.corpInfo.streetId=0;
					this.corpInfo.areaId=0;					 	
		    		this.getAreaList();
		        })
		        .catch((err) => {
		            console.log(err);
		        });
		    },
		    //获取区县列表
		    getAreaList(){
				if (this.corpInfo.cityId==0) return true;
		    	let url = "/ajax/district/area/"+this.corpInfo.cityId;
		    	this.$ajax.get(url).then((res) => {
					this.corpInfo.streetId=0;
					this.streetList=[];
		    		this.areaList = res.result;
		        })
		        .catch((err) => {
		            console.log(err);
		        });
		    },
		    //获取街道列表
		    getStreetList(){
				// /ajax/district/street/{areaId}
				if (this.corpInfo.areaId==0) return true;
		    	let url = "/ajax/district/street/" + this.corpInfo.areaId;
		    	this.$ajax.get(url).then((res) => {
		        	//console.log(res);
		    		this.streetList = res.result;
		        })
		        .catch((err) => {
		            console.log(err);
		        });
		    },
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/getArea/index.vue